module.exports = __webpack_public_path__ + "img/cgjz-7.ed0b985f.jpg";